import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/typescript";
import { optimizeProductImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
var NUMBER_OF_IMAGES_TO_SHOW = 3;
export var OrderSummaryCardImages = function OrderSummaryCardImages(_ref) {
  var _selectedBrandOrder$b;
  var selectedBrandOrder = _ref.selectedBrandOrder;
  var orderItems = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b === void 0 ? void 0 : _selectedBrandOrder$b.order_items;
  var images = orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function (orderItem) {
    return _objectSpread({
      order_item_token: orderItem.token
    }, orderItem === null || orderItem === void 0 ? void 0 : orderItem.product_image);
  }).filter(isNotUndefined);
  if (!images) {
    return null;
  }
  if (images.length <= 3) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, images.map(function (image, index) {
      if (!image) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Row, {
        key: image.order_item_token
      }, index !== 0 ? /*#__PURE__*/React.createElement(Spacer, {
        width: "1x"
      }) : null, /*#__PURE__*/React.createElement(ProductImage, {
        src: optimizeProductImageUrl(image, false, 60)
      }));
    }));
  }
  //If there are more than 3 images, we only want to show the first 3 with an overlay of #images not shown
  return /*#__PURE__*/React.createElement(React.Fragment, null, images.map(function (image, index) {
    if (!image || index >= NUMBER_OF_IMAGES_TO_SHOW) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Row, {
      key: image.order_item_token
    }, index !== 0 ? /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }) : null, index === NUMBER_OF_IMAGES_TO_SHOW - 1 && images ? (/*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansMedium",
      color: Core.text.inverse
    }, "+".concat((images === null || images === void 0 ? void 0 : images.length) - NUMBER_OF_IMAGES_TO_SHOW))), /*#__PURE__*/React.createElement(ProductImage, {
      src: optimizeProductImageUrl(image, false, 60)
    }))) : (/*#__PURE__*/React.createElement(ProductImage, {
      src: optimizeProductImageUrl(image, false, 60)
    })));
  }));
};
var ProductImage = styled.img.withConfig({
  displayName: "OrderSummaryCardImages__ProductImage"
})(["height:60px;width:60px;"]);
var Overlay = styled(Column).attrs({
  align: "center",
  justify: "center"
}).withConfig({
  displayName: "OrderSummaryCardImages__Overlay"
})(["position:absolute;background-color:", ";opacity:0.7;height:60px;width:60px;"], Core.surface.default);
var ImageWrapper = styled.div.withConfig({
  displayName: "OrderSummaryCardImages__ImageWrapper"
})(["position:relative;"]);